/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {AngularModalService} from '../common/modal/angular-modal.service';
import {SiteBulkActionModalComponent} from './site-bulk-action-modal.component';

@Injectable({providedIn: 'root'})
export class SiteBulkActionService {
  constructor(private readonly angularModalService: AngularModalService) {
  }

  createBulkAction(list: any): () => void {
    return () => {
      this.angularModalService.show(SiteBulkActionModalComponent, {
        class: 'modal-lg',
        initialState: {list}
      });
    };
  }
}
